export default __webpack_public_path__ + "static/media/bg.57ff3e3e.jpg";